import type { ComponentProps, ComponentState, Slot, Toolbar } from '@fluentui/react-components';

export type UserMessageSlots = {
  /**
   * The root slot for UserMessage
   */
  root: NonNullable<Slot<'div'>>;

  /*
   * The label slot is only exposed to screen reader users, and is used in two ways:
   * 1. It prepends the text content in the message's accessible name, e.g. "You wrote: [text content]"
   * 2. It is exposed as a heading to facilitate easy heading-based message navigation
   * NOTE: we recommend the text content of this slot to be "You wrote: " or "You wrote at [timestamp]: ".
   */
  accessibleHeading?: Slot<'h5', 'div'>;

  /**
   * The slot for the timestamp of the message
   */
  timestamp?: Slot<'span'>;

  /**
   * The slot for the accessible button
   */
  actionBarAccessibleButton?: Slot<'button'>;

  /**
   * The slot for the action bar above the message
   */
  actionBar?: Slot<typeof Toolbar>;

  /**
   * The slot for the message content. UserMessage's children are forwarded to this slot.
   */
  message?: NonNullable<Slot<'div'>>;
};

/**
 * UserMessage Props
 */
export type UserMessageProps = ComponentProps<UserMessageSlots> & {
  /*
   * Defines the screen reader live region message fired when the message is first inserted, and on any updates to the prop value.
   * Defaults to "You wrote: {message text content}"
   */
  announcement?: string;
};

/**
 * State used in rendering UserMessage
 */
export type UserMessageState = ComponentState<Required<UserMessageSlots>>;
